import React from 'react';
import SelectionCard from '../SelectionCard';

/**
 * CampaignFrameSection - Select campaign frame (core rules or custom frames)
 */
function CampaignFrameSection({ character, onUpdate, allData }) {
  const frames = allData.campaignFrames || {};

  // Always include core rules
  const frameOptions = [
    { id: 'core', name: 'Core Rules', description: 'Standard Daggerheart rules and equipment' },
    ...Object.entries(frames)
      .filter(([id]) => id !== 'core')
      .map(([id, data]) => ({
        id,
        name: data.name,
        description: data.description
      }))
  ];

  function handleSelect(frameId) {
    onUpdate({
      campaignFrame: frameId
    });
  }

  return (
    <div className="space-y-4">
      <p className="text-gray-300 text-small mb-4">
        Choose which campaign frame your character will use. This affects available equipment and starting items.
      </p>

      <div className="grid gap-3 md:grid-cols-2">
        {frameOptions.map(frame => (
          <SelectionCard
            key={frame.id}
            title={frame.name}
            description={frame.description}
            isSelected={character.campaignFrame === frame.id}
            onClick={() => handleSelect(frame.id)}
          />
        ))}
      </div>
    </div>
  );
}

export default CampaignFrameSection;
